import { COLORS, css, uiTokens } from '@msdk/ui'

export const SidebarItem = css`
  color: ${COLORS.primary.contrast};
  padding: 8px;
  display: flex;
  border-radius: 8px;
  flex-shrink: 0;
  align-self: stretch;
  align-items: center;
  gap: 20px;
  cursor: pointer;

  &:link {
    color: inherit;
  }

  &:visited {
    color: inherit;
  }

  &:focus {
    background-color: unset;
  }

  &.active {
    background-color: ${COLORS.components.navigation.dark};
  }

  &.open {
    background-color: ${COLORS.white.selected};
  }

  &:hover {
    background-color: ${COLORS.white.selected};
  }
`

export const NovaSidebarItem = css`
  color: ${uiTokens.uiContent.accent};
  padding: 8px;
  display: flex;
  border-radius: 8px;
  flex-shrink: 0;
  align-self: stretch;
  align-items: center;
  gap: 20px;
  cursor: pointer;

  height: 44px;
  min-height: 44px;
  max-height: 44px;

  &.active:not(.open) {
    position: relative;

    color: ${uiTokens.color.basic.black};
  }

  &.active:not(.open)::before {
    content: '';
    position: absolute;
    left: -12px;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: ${uiTokens.uiContent.accent};
    border-radius: 0 8px 8px 0;
  }

  &.open {
    background-color: ${uiTokens.uiSurface.pressedOrSelected};
  }

  &:hover {
    background-color: ${uiTokens.uiSurface.hover};
  }

  &:focus {
    background-color: none;
  }

  &.MuiListItem-gutters > * {
    padding-left: 0;
    padding-right: 0;
  }
`
